import AuthorizationController from '../app/authorization/AuthorizationController';
import { Roles } from './User';
// tslint:disable-next-line:ordered-imports
import { DashboardTranslates, DashboardCustomers, DashboarProjects, DashboardProjectLink,  DashboardPrivacy, DashboardBenefits, DashboardConclusion, DashboardUsps, DashboardPosts, DashboardServices, HashTagsViewController, DashboardReviews, DashboardWorks, DashboardGrabFormsViewController } from '../app/dashboard';
// tslint:disable-next-line:variable-name
export const Model: { [name: string]: { [name: string]: { exact: boolean, route: string, accessForRoles: any[], title?: string, controller: any } } } = {
    Home: {
        Main: {
            exact: true,
            route: '/',
            accessForRoles: [],
            controller: DashboardPosts.PostsMainController
        }
    },
    SignIn: {
        Main: {
            exact: true,
            route: '/signin',
            accessForRoles: [],
            controller: AuthorizationController
        }
    },
    Posts: {
        Main: {
            exact: true,
            route: '/posts',
            accessForRoles: [Roles.Admin, Roles.ContentManager, Roles.Editor],
            title: 'Посты',
            controller: DashboardPosts.PostsMainController
        },
        Add: {
            exact: false,
            route: '/posts/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager, Roles.Editor],
            title: 'Создание поста',
            controller: DashboardPosts.PostsAddEditController
        },
        Edit: {
            exact: false,
            route: '/posts/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager, Roles.Editor],
            title: 'Редактирование поста',
            controller: DashboardPosts.PostsAddEditController
        }
    },
    Services: {
        Main: {
            exact: true,
            route: '/services',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Услуги',
            controller: DashboardServices.ServicesMainController
        },
        Add: {
            exact: false,
            route: '/services/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание услуги',
            controller: DashboardServices.ServicesAddEditController
        },
        Edit: {
            exact: false,
            route: '/services/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование услуги',
            controller: DashboardServices.ServicesAddEditController
        }
    },
    Projects: {
        Main: {
            exact: true,
            route: '/projects',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Проекты',
            controller: DashboarProjects.ProjectsMainController
        },
        Add: {
            exact: false,
            route: '/projects/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание проекта',
            controller: DashboarProjects.ProjectAddEditController
        },
        Edit: {
            exact: false,
            route: '/projects/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование проекта',
            controller: DashboarProjects.ProjectAddEditController
        }
    },
    Translates: {
        Main: {
            exact: true,
            route: '/translates',
            accessForRoles: [Roles.Admin, Roles.Translator],
            title: 'Переводы',
            controller: DashboardTranslates
        }
    },
    Benefits: {
        Main: {
            exact: true,
            route: '/benefits',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Преимущества',
            controller: DashboardBenefits.BenefitsMainController
        },
        Add: {
            exact: false,
            route: '/benefits/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание преимущества',
            controller: DashboardBenefits.BenefitsAddEditController
        },
        Edit: {
            exact: false,
            route: '/benefits/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование преимущества',
            controller: DashboardBenefits.BenefitsAddEditController
        }
    },
    Usps: {
        Main: {
            exact: true,
            route: '/usps',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'УТП',
            controller: DashboardUsps.UspsMainController
        },
        Add: {
            exact: false,
            route: '/usps/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание УТП',
            controller: DashboardUsps.UspsAddEditController
        },
        Edit: {
            exact: false,
            route: '/usps/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование УТП',
            controller: DashboardUsps.UspsAddEditController
        }
    },
    Reviews: {
        Main: {
            exact: true,
            route: '/reviews',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Отзывы',
            controller: DashboardReviews.ReviewsMainController
        },
        Add: {
            exact: false,
            route: '/reviews/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание отзыва',
            controller: DashboardReviews.ReviewAddEditViewController
        },
        Edit: {
            exact: false,
            route: '/reviews/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование отзыва',
            controller: DashboardReviews.ReviewAddEditViewController
        }
    },
    Works: {
        Main: {
            exact: true,
            route: '/works',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Работы',
            controller: DashboardWorks.WorksMainController
        },
        Add: {
            exact: false,
            route: '/works/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание работы',
            controller: DashboardWorks.WorkAddEditViewController
        },
        Edit: {
            exact: false,
            route: '/works/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование работы',
            controller: DashboardWorks.WorkAddEditViewController
        }
    },
    GranForms: {
        Main: {
            exact: true,
            route: '/grab-forms',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Формы захвата',
            controller: DashboardGrabFormsViewController.GrabFormsMainController
        },
        Add: {
            exact: false,
            route: '/grab-forms/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание формы',
            controller: DashboardGrabFormsViewController.GrabFormAddEditViewController
        },
        Edit: {
            exact: false,
            route: '/grab-forms/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование формы',
            controller: DashboardGrabFormsViewController.GrabFormAddEditViewController
        }
    },
    Conclusions: {
        Main: {
            exact: true,
            route: '/conclusions',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'ПостУТП',
            controller: DashboardConclusion.ConclusionsMainController
        },
        Add: {
            exact: false,
            route: '/conclusions/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание ПостУТП',
            controller: DashboardConclusion.ConclusionsAddEditController
        },
        Edit: {
            exact: false,
            route: '/conclusions/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование ПостУТП',
            controller: DashboardConclusion.ConclusionsAddEditController
        }
    },
    Customers: {
        Main: {
            exact: true,
            route: '/customers',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Клиенты',
            controller: DashboardCustomers.CustomersMainController
        },
        Add: {
            exact: false,
            route: '/customers/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание клиента',
            controller: DashboardCustomers.CustomersAddEditController
        },
        Edit: {
            exact: false,
            route: '/customers/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование клиента',
            controller: DashboardCustomers.CustomersAddEditController
        }
    },
    ProjectLinks: {
        Main: {
            exact: true,
            route: '/project-links',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Проектная ссылка',
            controller: DashboardProjectLink.ProjectLinkMainController
        },
        Add: {
            exact: false,
            route: '/project-links/add',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Создание проектной ссылки',
            controller: DashboardProjectLink.ProjectLinkAddEditController
        },
        Edit: {
            exact: false,
            route: '/project-links/edit',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Редактирование проектной ссылки',
            controller: DashboardProjectLink.ProjectLinkAddEditController
        }
    },
    Hashtags: {
        Main: {
            exact: true,
            route: '/hashtags',
            accessForRoles: [Roles.Admin, Roles.ContentManager],
            title: 'Хэштеги',
            controller: HashTagsViewController
        }
    },
    Privacy: {
        Main: {
            exact: true,
            route: '/privacy',
            accessForRoles: [Roles.Admin],
            title: 'Политика конфиденциальности',
            controller: DashboardPrivacy
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/Routes.ts